import { makeAutoObservable } from 'mobx';
import { IActivationDataPayload } from './types';
import { getPersistedValue } from 'helpers';
import {
	UPGRADE_LIFETIME_VERSION,
	UPSALE_PDF,
} from 'modules/activationInstructions/components/paymentSuccessfulV1/params';

export interface IActivationStore {
	activationData?: IActivationDataPayload;
	upgradeLifetime?: UPGRADE_LIFETIME_VERSION;
	upsalePdf?: UPSALE_PDF;
	setActivationData: (activationData: IActivationDataPayload) => void;
}

enum STORAGE_KEYS {
	activationData = 'activationData',
}

export class ActivationInstructionsStore implements IActivationStore {
	activationData?: IActivationDataPayload;
	upgradeLifetime?: UPGRADE_LIFETIME_VERSION;
	upsalePdf?: UPSALE_PDF;

	constructor(
		storage: Storage,
		upgradeLifetime?: UPGRADE_LIFETIME_VERSION,
		upsalePdf?: UPSALE_PDF,
	) {
		makeAutoObservable(this);

		this.upgradeLifetime = upgradeLifetime;
		this.upsalePdf = upsalePdf;
		this.activationData = getPersistedValue(STORAGE_KEYS.activationData, storage);
	}

	setActivationData = (activationData: IActivationDataPayload): void => {
		this.activationData = activationData;
	};
}
